<template>
  <div class="portal-page info-story">
    <div class="portal-page__inner">
      <p v-if="errorMessage" class="info-story__status">{{ errorMessage }}</p>
      <article v-else-if="story" class="info-story__card portal-panel">
        <p class="info-story__kicker">{{ story.categoryLabel }}</p>
        <h1 class="info-story__title">{{ story.title }}</h1>
        <p class="info-story__date">{{ formatDate(story.publishedAt) }}</p>
        <img v-if="story.heroImage || story.thumb" class="info-story__image" :src="story.heroImage || story.thumb" alt="" />
        <p class="info-story__summary">{{ story.summary }}</p>
        <router-link to="/info" class="portal-btn portal-btn--secondary">정보마당 목록</router-link>
      </article>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { fetchInfoStory, type InfoStory } from '@/api/infoCenter'

const route = useRoute()
const story = ref<InfoStory | null>(null)
const errorMessage = ref('')

function formatDate(value: string) {
  return String(value || '').replace(/-/g, '.')
}

onMounted(async () => {
  try {
    story.value = await fetchInfoStory(Number(route.params.idx))
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : '소식을 불러오지 못했습니다.'
  }
})
</script>

<style lang="scss" src="./InfoStoryPage.scss"></style>
